module.exports = __webpack_public_path__ + "static/media/carsis-car-1.e433564c.jpg";